export class ErrorResp {
    error: string;
    result: string;
    debug: string;

    constructor() {
        this.error = '';
        this.result = '';
        this.debug = '';
    }
}

export class ErrorRespApi {
    Error: string;
    Result: string;

    constructor() {
        this.Error = '';
        this.Result = '';
    }
}

export class MyReq {
    store: string;
    myToken: string;

    constructor() {
        this.store = '';
        this.myToken = '';
    }
}